import { createBrowserRouter } from 'react-router-dom';

import RootLayout from './pages/Layout';
import LoginPage from './pages/Login';
import SignupPage from './pages/Signup';
import ForgotPasswordPage from './pages/ForgotPassword';
import ResetPasswordPage from './pages/ResetPassword';
import VerifyEmailPage from './pages/VerifyEmail';
import GraphiQLEditor from './components/GraphiQLEditor';
import AuthGuard from './components/AuthGuard';

import BlocksRoutes from './pages/blocks';
import WorkflowRoutes from './pages/workflows';
import TransactionsRoutes from './pages/transactions';
import EventsRoutes from './pages/events';
import ContractsRoutes from './pages/contracts';
import AddressesRoutes from './pages/addresses';
import EntitiesRoutes from './pages/entities';
import ListsRoutes from './pages/lists';
import AlertsRoutes from './pages/alerts';
import SignalsRoutes from './pages/signals';
import NotificationsRoutes from './pages/notifications';
import SettingsPage from './pages/settings';
import IntegrationsPage from './pages/settings/integrations';
import ProfilePage from './pages/settings/profile';
import ApiKeysPage from './pages/settings/api-keys';

const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/verify-email',
    element: <VerifyEmailPage />,
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <RootLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: 'blocks',
        children: BlocksRoutes,
      },
      {
        path: 'transactions',
        children: TransactionsRoutes,
      },
      {
        path: 'events',
        children: EventsRoutes,
      },
      {
        path: 'contracts',
        children: ContractsRoutes,
      },
      {
        path: 'addresses',
        children: AddressesRoutes,
      },
      {
        path: 'entities',
        children: EntitiesRoutes,
      },
      {
        path: 'lists',
        children: ListsRoutes,
      },
      {
        path: 'alerts',
        children: AlertsRoutes,
      },
      {
        path: 'signals',
        children: SignalsRoutes,
      },
      {
        path: 'notifications',
        children: NotificationsRoutes,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
        children: [
          {
            path: 'integrations',
            element: <IntegrationsPage />,
          },
          {
            path: 'api-keys',
            element: <ApiKeysPage />,
          },
          {
            path: 'profile',
            element: <ProfilePage />,
          },
        ],
      },
    ],
  },
  {
    path: 'workflows',
    children: WorkflowRoutes.map((route) => ({
      ...route,
      element: <AuthGuard>{route.element}</AuthGuard>,
    })),
  },
  {
    path: 'graphiql',
    element: (
      <AuthGuard>
        <GraphiQLEditor />
      </AuthGuard>
    ),
  },
]);

export default router;
